import { ProgressIndicator } from '@fluentui/react'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { ConnectedRouter } from 'connected-react-router'
import { reactPlugin } from 'global/Application/AppInsight'
import ApplicationContextProvider from 'global/Application/Context'
import { useAuthentication } from "global/Authentication"
import Debugger from 'global/Debugger'
import { Suspense } from 'react'
import { Route, Switch } from "react-router-dom"
import AccountsReceivable from 'views/BlueRelationship/AccountsReceivable'
import ActionItem from 'views/BlueRelationship/ActionItem'
import Benefit from 'views/BlueRelationship/Benefit'
import BlueRelationship from 'views/BlueRelationship/BlueRelationship'
import CheckList from 'views/BlueRelationship/CheckList/CheckList'
import CheckListItem from 'views/BlueRelationship/CheckList/CheckListItem/CheckListItem'
import CompareContext from 'views/BlueRelationship/Compare'
import ConfigAttributeDiagnosis from 'views/BlueRelationship/ConfigAttributeDiagnosis'
import FeesAndPremium from 'views/BlueRelationship/FeesAndPremium'
import Finished from 'views/BlueRelationship/Fnished'
import PharmacyContext from 'views/BlueRelationship/Pharmacy/PharmacyList/index'
import PharmacyPlan from 'views/BlueRelationship/Pharmacy/PharmacyPlan'
import StopLoss from 'views/BlueRelationship/StopLoss'
import Timeline from 'views/BlueRelationship/Timeline'
import QuoteRequest from 'views/QuoteRequest'
import { history } from './app/store'
import { AutoSwitchLayout } from './components/layout'
import { ComingSoon, NoMatch } from "./components/route"
import GroupConfiguration from './views/BlueRelationship/GroupConfiguration'
import NonStandardTemplates from './views/BlueRelationship/NonStandardTemplates'
import AssociationTemplates from './views/BlueRelationship/AssociationTemplates'
import Plan from './views/BlueRelationship/Plan'
import ComparisonTool from "./views/Comparison/ComparisonTool"
import LoadGroupHeaders from "./views/Comparison/LoadGroupHeaders"
import PharmacyLanding from "./views/Comparison/PharmacyLanding"
import PharmacyTool from "./views/Comparison/PharmacyTool"
import SubgroupInformation from "./views/Comparison/SubgroupInformationReport"
import Dashboard from './views/Dashboard'
import Login from './views/Login'
import Redirect from './views/Redirect'
import Stencil from './views/Stencil'

export interface RouterParams {

    // TODO rename this to accountId
    id?: string;

    // TODO rename bcbs_groupconfigurationsnapshotid
    snapshotId?: string;
    planId?: string;
    benefitId?: string;
    tabId?: string;
    sectionId?: string;
    fieldId?: string;
    nonStandardId?: string;
    groupNumberId?: string;
    flexibleFieldSetId?: string;
    feesAndPremiumId?: string;
    stopLossId?: string;
    snapshot1?: string;
    snapshot2?: string;
    claimsARId?: string;
    plan1?: string;

    tab2ndId?: string;
    section2ndId?: string;
    field2ndId?: string;

    bcbs_emchecklistid?: string;

    bcbs_opportunityproductid?: string;
    bcbs_opportunityoptionid?: string;

    pharmacyId?: string;

    compareId?: string;
}


const App = () => {
    const { isAuthenticated, authorizations } = useAuthentication();

    const attachDebugger = !!authorizations?.roles['BCBS - Power User'];

    const renderWithLayout = (Component: any, additionalProps?: any) => (props: any) => {

        if (isAuthenticated)
            return (
                <AutoSwitchLayout {...props}>
                    {attachDebugger && <Debugger />}
                    <Component
                        {...props}
                        {...additionalProps}
                    />
                </AutoSwitchLayout>
            )

        return (
            <AutoSwitchLayout {...props}>
                <Login {...props} />
            </AutoSwitchLayout>
        )
    };

    const blueRelationshipRoute = `/records/blueRelationship/:id`;
    const group = `${blueRelationshipRoute}/groupConfiguration/:snapshotId`;
    const plan = `/plan/:planId`;

    const benefit = `/benefit/:benefitId`;
    const tab = `/tab/:tabId`;
    const section = `/section/:sectionId`;
    const field = `/field/:fieldId`;
    const feesAndPremium = `/feesAndPremium/:feesAndPremiumId`;
    const stopLoss = `/stopLoss/:stopLossId`;
    const groupNumber = `/groupNumber/:groupNumberId`;
    const accountsReceivable = `/claimsAR/:claimsARId`;
    const nonstandardRoute = `/nonStandard/:nonStandardId`;
    const flexibleFieldSetRoute = `/flexibleFieldSet/:flexibleFieldSetId`;

    const checklistRoute = `/checklist`;

    const tab2nd = `/tab/:tab2ndId`;
    const section2nd = `/section/:section2ndId`;
    const field2nd = `/field/:field2ndId`;

    return (
        <ConnectedRouter history={history}>
            <ApplicationContextProvider>
                <Suspense fallback={<ProgressIndicator label="Page loading..." />}>
                    <Switch>
                        <Route path="/redirect" component={Redirect} />
                        <Route path="/login" component={renderWithLayout(Login)} />
                        <Route
                            path="/"
                            exact
                            component={renderWithLayout(Dashboard)}
                        />
                        <Route
                            path="/profile"
                            exact
                            component={renderWithLayout(ComingSoon)}
                        />
                        <Route
                            path="/management"
                            exact
                            component={renderWithLayout(ComingSoon)}
                        />
                        <Route
                            path="/management/timeline"
                            exact
                            component={renderWithLayout(ComingSoon)}
                        />
                        <Route
                            path="/management/settings"
                            exact
                            component={renderWithLayout(ComingSoon)}
                        />
                        <Route
                            path="/subgroupInformation/:id/:snapshotId/"
                            exact
                            component={renderWithLayout(SubgroupInformation)}
                        />
                        <Route
                            path="/pharmacyLanding/:id/:snapshot1/:snapshot2"
                            exact
                            component={renderWithLayout(PharmacyLanding)}
                        />
                        <Route
                            path="/pharmacyLanding/:id/:snapshot1/"
                            exact
                            component={renderWithLayout(PharmacyLanding)}
                        />

                        <Route
                            path="/pharmacy/:id/:snapshot1/:plan1"
                            exact
                            component={renderWithLayout(PharmacyTool)}
                        />
                        <Route
                            path="/pharmacy/:id/:snapshot1/:plan1/:snapshot2"
                            exact
                            component={renderWithLayout(PharmacyTool)}
                        />
                        <Route
                            path="/groupHeaders/:id/:snapshotId/:planId"
                            exact
                            component={renderWithLayout(LoadGroupHeaders)}
                        />
                        <Route
                            path="/comparison/:id/:snapshot1/:snapshot2"
                            exact
                            component={renderWithLayout(ComparisonTool)}
                        />
                        <Route
                            path="/comparison/:id/:snapshot2"
                            exact
                            component={renderWithLayout(ComparisonTool)}
                        />
                        <Route
                            path="/comparison/:id"
                            exact
                            component={renderWithLayout(ComparisonTool)}
                        />
                        <Route
                            path="/underwritingReview/:id/:snapshot1/:snapshot2"
                            exact
                            component={renderWithLayout(ComparisonTool)}
                        />
                        <Route
                            path="/underwritingReview/:id/:snapshot2/"
                            exact
                            component={renderWithLayout(ComparisonTool)}
                        />
                        <Route
                            path="/merge/:id"
                            exact
                            component={renderWithLayout(ComparisonTool)}
                        />
                        <Route
                            path="/merge/:id/:snapshot1"
                            exact
                            component={renderWithLayout(ComparisonTool)}
                        />
                        <Route
                            path="/merge/:id/:snapshot1/:snapshot2"
                            exact
                            component={renderWithLayout(ComparisonTool)}
                        />
                        <Route
                            path="/records/blueRelationship"
                            exact
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path="/records/contacts"
                            exact
                            component={renderWithLayout(ComingSoon)}
                        />

                        <Route
                            path={group + checklistRoute + '/list'}
                            component={renderWithLayout(CheckList)}
                        />
                        <Route
                            path={group + checklistRoute + "/:bcbs_emchecklistid"}
                            component={renderWithLayout(CheckListItem)}
                        />
                        <Route
                            path={group + '/nonstandardtemplates'}
                            component={renderWithLayout(NonStandardTemplates)}
                        />
                        <Route
                            path={group + '/associationtemplates'}
                            component={renderWithLayout(AssociationTemplates)}
                        />
                        <Route
                            path={group + groupNumber + tab2nd + section2nd + field2nd}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + groupNumber + tab2nd + section2nd}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + groupNumber + tab2nd}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + groupNumber}
                            exact
                            component={renderWithLayout(GroupConfiguration)}
                        />


                        <Route
                            path={group + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + tab + section + flexibleFieldSetRoute}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + tab + section + nonstandardRoute + tab2nd + section2nd + field2nd}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + tab + section + nonstandardRoute + tab2nd + section2nd}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + tab + section + nonstandardRoute + tab2nd}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + tab + section + nonstandardRoute}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + tab + section + field}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + tab + section}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group + tab}
                            component={renderWithLayout(GroupConfiguration)}
                        />
                        <Route
                            path={group}
                            exact
                            component={renderWithLayout(GroupConfiguration)}
                        />

                        <Route
                            path={group + plan + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan + tab + section + flexibleFieldSetRoute}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan + tab + section + nonstandardRoute + tab2nd + section2nd + field2nd}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan + tab + section + nonstandardRoute + tab2nd + section2nd}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan + tab + section + nonstandardRoute + tab2nd}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan + tab + section + nonstandardRoute}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan + tab + section + field}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan + tab + section}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan + tab}
                            component={renderWithLayout(Plan)}
                        />
                        <Route
                            path={group + plan}
                            component={renderWithLayout(Plan)}
                        />

                        <Route
                            path={group + `/prime/florida/plan/:pharmacyId`}
                            component={renderWithLayout(PharmacyPlan, {
                                isFloridaPrime: true
                            })}
                        />

                        <Route
                            path={group + `/prime/florida`}
                            component={renderWithLayout(PharmacyContext, {
                                isFloridaPrime: true
                            })}
                        />

                        <Route
                            path={group + `/prime/capital/plan/:pharmacyId`}
                            component={renderWithLayout(PharmacyPlan, {
                                isCapitalPrime: true
                            })}
                        />

                        <Route
                            path={group + `/prime/capital`}
                            component={renderWithLayout(PharmacyContext, {
                                isCapitalPrime: true
                            })}
                        />


                        <Route
                            path={group + `/merge/:compareId`}
                            component={renderWithLayout(CompareContext, {
                                isMergeApp: true
                            })}
                        />

                        <Route
                            path={group + `/merge`}
                            component={renderWithLayout(CompareContext, {
                                isMergeApp: true
                            })}
                        />

                        <Route
                            path={group + `/compare/:compareId`}
                            component={renderWithLayout(CompareContext, {
                                isCompareApp: true
                            })}
                        />

                        <Route
                            path={group + `/compare`}
                            component={renderWithLayout(CompareContext, {
                                isCompareApp: true
                            })}
                        />

                        <Route
                            path={group + `/underwriting/:compareId`}
                            component={renderWithLayout(CompareContext, {
                                isUnderwritingReviewApp: true
                            })}
                        />

                        <Route
                            path={group + `/underwriting`}
                            component={renderWithLayout(CompareContext, {
                                isUnderwritingReviewApp: true
                            })}
                        />

                        <Route
                            path={group + benefit + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit + tab + section + flexibleFieldSetRoute}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit + tab + section + nonstandardRoute + tab2nd + section2nd + field2nd}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit + tab + section + nonstandardRoute + tab2nd + section2nd}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit + tab + section + nonstandardRoute + tab2nd}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit + tab + section + nonstandardRoute}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit + tab + section + field}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit + tab + section}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit + tab}
                            component={renderWithLayout(Benefit)}
                        />
                        <Route
                            path={group + benefit}
                            component={renderWithLayout(Benefit)}
                        />



                        <Route
                            path={group + stopLoss + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={renderWithLayout(StopLoss)}
                        />
                        <Route
                            path={group + stopLoss + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={renderWithLayout(StopLoss)}
                        />
                        <Route
                            path={group + stopLoss + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={renderWithLayout(StopLoss)}
                        />
                        <Route
                            path={group + stopLoss + tab + section + flexibleFieldSetRoute}
                            component={renderWithLayout(StopLoss)}
                        />
                        <Route
                            path={group + stopLoss + tab + section + field}
                            component={renderWithLayout(StopLoss)}
                        />
                        <Route
                            path={group + stopLoss + tab + section}
                            component={renderWithLayout(StopLoss)}
                        />
                        <Route
                            path={group + stopLoss + tab}
                            component={renderWithLayout(StopLoss)}
                        />
                        <Route
                            path={group + stopLoss}
                            component={renderWithLayout(StopLoss)}
                        />


                        <Route
                            path={group + feesAndPremium + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={renderWithLayout(FeesAndPremium)}
                        />
                        <Route
                            path={group + feesAndPremium + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={renderWithLayout(FeesAndPremium)}
                        />
                        <Route
                            path={group + feesAndPremium + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={renderWithLayout(FeesAndPremium)}
                        />
                        <Route
                            path={group + feesAndPremium + tab + section + flexibleFieldSetRoute}
                            component={renderWithLayout(FeesAndPremium)}
                        />
                        <Route
                            path={group + feesAndPremium + tab + section + field}
                            component={renderWithLayout(FeesAndPremium)}
                        />
                        <Route
                            path={group + feesAndPremium + tab + section}
                            component={renderWithLayout(FeesAndPremium)}
                        />
                        <Route
                            path={group + feesAndPremium + tab}
                            component={renderWithLayout(FeesAndPremium)}
                        />
                        <Route
                            path={group + feesAndPremium}
                            component={renderWithLayout(FeesAndPremium)}
                        />



                        <Route
                            path={group + accountsReceivable + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={renderWithLayout(AccountsReceivable)}
                        />
                        <Route
                            path={group + accountsReceivable + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={renderWithLayout(AccountsReceivable)}
                        />
                        <Route
                            path={group + accountsReceivable + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={renderWithLayout(AccountsReceivable)}
                        />
                        <Route
                            path={group + accountsReceivable + tab + section + flexibleFieldSetRoute}
                            component={renderWithLayout(AccountsReceivable)}
                        />
                        <Route
                            path={group + accountsReceivable + tab + section + field}
                            component={renderWithLayout(AccountsReceivable)}
                        />
                        <Route
                            path={group + accountsReceivable + tab + section}
                            component={renderWithLayout(AccountsReceivable)}
                        />
                        <Route
                            path={group + accountsReceivable + tab}
                            component={renderWithLayout(AccountsReceivable)}
                        />
                        <Route
                            path={group + accountsReceivable}
                            component={renderWithLayout(AccountsReceivable)}
                        />

                        <Route
                            path={group + '/complete'}
                            exact
                            component={renderWithLayout(Finished)}
                        />


                        <Route
                            path={'/bcbs_opportunityproduct/:bcbs_opportunityproductid/bcbs_opportunityoption/:bcbs_opportunityoptionid'}
                            exact
                            component={renderWithLayout(QuoteRequest)}
                        />

                        <Route
                            path={'/bcbs_opportunityproduct/:bcbs_opportunityproductid'}
                            exact
                            component={renderWithLayout(QuoteRequest)}
                        />

                        <Route
                            path={group + '/timeline'}
                            exact
                            component={renderWithLayout(Timeline)}
                        />

                        <Route
                            path={'/diagnosis/bcbs_config_attribute'}
                            exact
                            component={renderWithLayout(ConfigAttributeDiagnosis)}
                        />


                        <Route
                            path={'/diagnosis/bcbs_config_actionitem'}
                            exact
                            component={renderWithLayout(ActionItem)}
                        />

                        <Route
                            path={'/diagnosis'}
                            component={renderWithLayout(Debugger)}
                        />

                        <Route
                            path={'/finished'}
                            exact
                            component={renderWithLayout(Finished)}
                        />

                        <Route
                            path={blueRelationshipRoute}
                            exact
                            component={renderWithLayout(BlueRelationship)}
                        />

                        <Route
                            path={'/stencil'}
                            exact
                            component={Stencil}
                        />

                        <Route
                            path="*"
                            component={renderWithLayout(NoMatch)}
                        />
                    </Switch>
                </Suspense>
            </ApplicationContextProvider>
        </ConnectedRouter>
    );
}

export default withAITracking(reactPlugin, App);